export default __webpack_public_path__ + "static/media/stfrancisxavier.8588e590.jpg";